import { render, staticRenderFns } from "./adminManageUser.vue?vue&type=template&id=4085b440"
import script from "./adminManageUser.vue?vue&type=script&lang=js"
export * from "./adminManageUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports